/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */
import React from 'react';

/** A failed verification is not evidence that the human session has expired. */
export function isSessionVerificationUnavailable(error: unknown): boolean {
  const status = (error as { response?: { status?: number }; status?: number } | null)?.response?.status
    ?? (error as { status?: number } | null)?.status;
  return status !== 401 && status !== 403;
}

const copy: Record<string, readonly [string, string, string]> = {
  tr: ['Oturum doğrulanamıyor', 'Bağlantı geçici olarak kullanılamıyor. Oturumunuz kapatılmadı. Sayfayı yeniden yükleyerek tekrar deneyin.', 'Yeniden dene'],
  en: ['Session verification unavailable', 'The connection is temporarily unavailable. You have not been signed out. Reload this page to try again.', 'Try again'],
  ar: ['تعذر التحقق من الجلسة', 'الاتصال غير متاح مؤقتًا. لم يتم تسجيل خروجك. أعد تحميل الصفحة للمحاولة مرة أخرى.', 'إعادة المحاولة'],
  de: ['Sitzungsprüfung nicht verfügbar', 'Die Verbindung ist vorübergehend nicht verfügbar. Sie wurden nicht abgemeldet. Laden Sie die Seite erneut.', 'Erneut versuchen'],
  es: ['No se puede verificar la sesión', 'La conexión no está disponible temporalmente. No se ha cerrado tu sesión. Recarga esta página para volver a intentarlo.', 'Reintentar'],
  fr: ['Vérification de session indisponible', 'La connexion est temporairement indisponible. Vous n’avez pas été déconnecté. Rechargez cette page pour réessayer.', 'Réessayer'],
  it: ['Verifica della sessione non disponibile', 'La connessione è temporaneamente non disponibile. Non è stata eseguita la disconnessione. Ricarica questa pagina per riprovare.', 'Riprova'],
  ja: ['セッションを確認できません', '接続を一時的に利用できません。ログアウトはしていません。ページを再読み込みしてお試しください。', '再試行'],
  ru: ['Проверка сеанса недоступна', 'Соединение временно недоступно. Выход из учётной записи не выполнен. Перезагрузите страницу и повторите попытку.', 'Повторить'],
  zh: ['暂时无法验证会话', '连接暂时不可用。您尚未被退出登录。请重新加载此页面后重试。', '重试'],
};

export function AuthSessionUnavailable({ language, onRetry }: { language: string; onRetry: () => void }): React.ReactElement {
  const [title, message, retry] = copy[language.split('-')[0]] ?? copy.en;
  return <main role="alert" dir={language.startsWith('ar') ? 'rtl' : undefined}
    style={{ padding: '2rem', color: 'var(--text-primary)', background: 'var(--bg-primary)', minHeight: '100vh' }}>
    <h1>{title}</h1><p>{message}</p>
    <button className="btn-primary" type="button" onClick={onRetry}>{retry}</button>
  </main>;
}
